<!-- 订单详情组件 -->
<template>
  <div>
    <div class="product-content"  v-if='orderGetter && orderGetter.subscription'>
      <!-- 有订阅情况 -->

      <div>
        <div class="product-header">
          <div class="amountWord">{{ $t('message.checkout.subscription') }}:{{ orderGetter &&
            orderGetter.subscription.productName }}</div>
          <!-- <div class="amountWord">{{ $t('message.checkout.amount') }}:</div> -->
          <!-- 有试用信息 -->
          <div class="hasFree" v-if="orderGetter && orderGetter.subscription.trialDays">
            <div class="amountNum" style="margin-top: 6px;">{{ orderGetter.subscription.trialDays
              }} {{ $t(`message.checkout.D`) }}
              {{ $t('message.checkout.free') }}</div>
            <div class="product-flex">
              <div class="amountWord"> {{ orderGetter &&
                orderGetter.txnAmount }} {{ orderGetter && orderGetter.txnCurrency }} <span>
                    {{ formatFrequencyLabel(orderGetter.subscription.frequencyType, orderGetter.subscription.frequencyPoint) }}
                    </span></div>
              <div class="amountIcon" @click="showDetail()"
                v-if="viewTxnId !== false || (orderGetter && orderGetter.website && !orderGetter.hideWebsite)">{{
                  showWord
                }} <span :class="[showDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></span>
              </div>
            </div>
          </div>
          <!-- 无订阅试用 -->
          <div v-else>
            <div class="amountNum" style="margin-top: 6px;">{{ orderGetter &&
              orderGetter.txnAmount }} {{ orderGetter && orderGetter.txnCurrency }}</div>
            <div class="product-flex">
              <div class="amountWord">
                {{ formatFrequencyLabel(orderGetter.subscription.frequencyType, orderGetter.subscription.frequencyPoint) }}
                </div>
              <div class="amountIcon" @click="showDetail()"
                v-if="viewTxnId !== false || (orderGetter && orderGetter.website && !orderGetter.hideWebsite)">{{
                  $t('message.checkout.details') }} <span
                  :class="[showDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showDetails" class="product-details">
          <div v-if="viewTxnId !== false" style="margin-bottom: 18px;">
            <div class="label">{{ $t('message.checkout.orderno') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.merchantTxnId }}</div>
          </div>
          <div v-if="orderGetter && orderGetter.website && !orderGetter.hideWebsite">
            <div class="label">{{ $t('message.checkout.website') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.website }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 无订阅 -->
    <div v-else class="product-content">
      <div :style="{ backgroundColor: isQr ? '#fff' : '#f9f9f9',borderRadius: isQr ? '8px' : '0' }">
        <div class="product-header">
          <div class="amountWord">{{ $t('message.checkout.amount') }}</div>
          <div class="product-flex" style="margin-top: 6px;align-items: flex-end !important;">
            <div class="amountNum"> {{ orderGetter &&
             (isQr?formatMoneyWithCommasQr(orderGetter.txnAmount):orderGetter.txnAmount) }} {{ orderGetter && orderGetter.txnCurrency }}

             <el-button class="button" type="text" @click="copyTicket" v-if="isQr">
              <span class="iconfont icon-rongqi"></span>
            </el-button>

            </div>
            <div class="amountIcon" @click="showDetail()" v-if="(viewTxnId !== false || !orderGetter?.hideWebsite)">{{
              showWord }} <span :class="[showDetails ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></span>
            </div>
          </div>
        </div>
        <div v-if="showDetails" class="product-details">
          <div v-if="viewTxnId !== false">
            <div class="label">{{ $t('message.checkout.orderno') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.merchantTxnId }}</div>
          </div>
          <div style="margin-top: 18px;" v-if="orderGetter && orderGetter.website && !orderGetter.hideWebsite">
            <div class="label">{{ $t('message.checkout.website') }}</div>
            <div class="label-detail">{{ orderGetter && orderGetter.website }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { formatMoneyWithCommasQr, formatMoneyWithCommas, formatFrequencyLabel } from '@/utils/tools/format';
import { copyString } from '@/utils/tools/utils';

export default {
  name: 'orderSummary',
  props: {
    orderGetter: {
      type: Object,
      default: null,
    },
    viewTxnId: {
      type: Boolean,
      default: true,
    },
    // 额外定制样式 适用于qr
    isQr: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showDetails: false,
      showWord: this.$t('message.checkout.details'),
    };
  },
  methods: {
    formatFrequencyLabel,
    formatMoneyWithCommasQr,
    formatMoneyWithCommas,
    showDetail() {
      this.showDetails = !this.showDetails;
      if (this.showDetails) {
        this.showWord = this.$t('message.checkout.fold');
      } else {
        this.showWord = this.$t('message.checkout.details');
      }
    },
    copyTicket() {
      copyString(this.orderGetter.txnAmount);
    },
  },
  mounted() {
    // this.orderGetter.hideWebsite = true
    setTimeout(() => {
    }, 500);
  },
};
</script>
<style lang="scss" scoped>
.product-content {
  padding: 0px 16px;
  box-sizing: border-box;
  // margin-bottom: 18px;

  // background-color: #F9F9F9;
  >div {
    border-radius: 8px 8px 8px 8px;
    background-color: #F9F9F9;
  }

  .product-header {
    padding: 16px;
    box-sizing: border-box;

    .amountWord {
      font-weight: 400;
      font-size: 14px;
      color: #667085;
      line-height: 18px;
      text-align: left;
    }

    .product-flex {
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
      align-items: center;

      .amountNum {
        font-size: 32px;
        color: #1A202C;
        line-height: 40px;
        text-align: left;
        font-weight: 600;

      }

      .amountIcon {
        font-size: 12px;
        color: #8D98AF;
        line-height: 22px;
        text-align: right;
        font-style: normal;
        position: relative;
        // bottom: 5px;
      }
    }
  }

  .product-details {
    padding: 8px 16px 16px;
    box-sizing: border-box;

    >div {
      display: flex;
      justify-content: space-between;

      .label {
        font-size: 14px;
        color: #667085;
        line-height: 18px;
        font-family: "Open Sans regular";

      }

      .label-detail {
        font-weight: 400;
        font-size: 14px;
        color: #1A202C;
        line-height: 18px;
        text-align: right;
        font-family: "Open Sans regular";
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-all;
        width: 206px;

      }
    }

  }

  .amountNum {
    font-size: 32px;
    color: #1A202C;
    line-height: 40px;
    text-align: left;
    font-weight: 600;
  }
}
</style>
